// extracted by mini-css-extract-plugin
export var fullWidthButton = "_h7-0";